import { useState, useEffect } from 'react'

import { logErrorAsync } from '_lib/utility'
import { getTrendingTerms } from '_services/data-explorer.js'

import { useEventFeedsContext } from '../../context/index.jsx'

function shuffleArray(array) {
  const newArray = [...array]

  for (let i = newArray.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = newArray[i]
    newArray[i] = newArray[j]
    newArray[j] = temp
  }

  return newArray
}

export const formatTopKeywordsData = (list) => {
  return shuffleArray(
    list.map((item) => {
      return {
        text: `${item?.keyword}`,
        size: Number(item?.size),
      }
    })
  )
}

const formatResponse = (response) => {
  const formattedResponse = {}

  Object.keys(response).forEach((key) => {
    formattedResponse[key] = response[key].map((item) => {
      return {
        text: item.term,
        size: item.events,
      }
    })
  })

  return formattedResponse
}

export const useTopKecc = ({
  field = 'keywords',
  lookback = 'yesterday',
  language = 'all',
  entityType,
} = {}) => {
  const [trendingTerms, setTrendingTerms] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const { data, id } = useEventFeedsContext()
  const [filter, setFilter] = useState(MAP_DEFAULT_FILTERS[field])

  useEffect(() => {
    const getData = async () => {
      if (data._id || id === 'discovery') {
        try {
          const requestConfig = {
            filters: data.filters,
            field,
            lookback,
            language,
            ...(entityType && { entity_type: entityType }),
          }

          setIsLoading(true)
          const response = await getTrendingTerms(requestConfig, false)
          setTrendingTerms(formatResponse(response))
          setFilter(MAP_DEFAULT_FILTERS[field])
        } catch (error) {
          logErrorAsync(error)
          toast.error(error.message)
        }
        setIsLoading(false)
      }
    }

    getData()
  }, [data.filters, field, lookback, language, entityType, id])

  return { trendingTerms, isLoading, filter, setFilter }
}

export const TYPES = [
  { label: 'Categories', value: 'categories' },
  { label: 'Concepts', value: 'concepts' },
  { label: 'Entities', value: 'entities' },
  { label: 'Keywords', value: 'keywords' },
]

export const PERIODS = [
  { label: 'Yesterday', value: 'yesterday' },
  { label: '1 week ago', value: '1_week' },
  { label: '1 month ago', value: '1_month' },
  { label: '3 months ago', value: '3_months' },
  { label: '6 months ago', value: '6_months' },
]

export const ENTITY_TYPES = [
  { label: 'Broadcaster', value: 'broadcaster' },
  { label: 'Company', value: 'company' },
  { label: 'Facility', value: 'facility' },
  { label: 'Health Conditions', value: 'health_conditions' },
  { label: 'Location', value: 'location' },
  { label: 'Movie', value: 'movie' },
  { label: 'Organization', value: 'organization' },
  { label: 'Person', value: 'person' },
  { label: 'Sport', value: 'sport' },
  { label: 'Sporting Event', value: 'sporting_event' },
  { label: 'Television Show', value: 'television_show' },
  { label: 'Vehicle', value: 'vehicle' },
]

export const FILTERS = [
  { label: 'Popular', value: 'popular' },
  { label: 'Trending', value: 'trending' },
  { label: 'Popular and Trending', value: 'popular_and_trending' },
]

export const MAP_DEFAULT_FILTERS = {
  categories: 'popular',
  concepts: 'trending',
  entities: 'popular_and_trending',
  keywords: 'trending',
}

const COLORS = [
  '#13682B',
  '#5BAC4D',
  '#34158C',
  '#A40965',
  '#8C3A6D',
  '#146A59',
  '#0CB2B2',
  '#7DE2D3',
  '#FF2710',
]

export const MAP_TYPES_TO_COLORS = {
  categories: COLORS[0],
  concepts: COLORS[1],
  entities: COLORS[2],
  keywords: COLORS[3],
}

export const VISUALIZATION_TYPES = {
  WORD_CLOUD: 'wordCloud',
  BAR_CHART: 'barChart',
}
